/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export var ScenarioAPIPermissions;
(function (ScenarioAPIPermissions) {
    ScenarioAPIPermissions["WRITE_APPROVAL_ORIGINATION"] = "write:scenario:approval:origination";
    ScenarioAPIPermissions["WRITE_APPROVAL_TXM"] = "write:scenario:approval:transmission";
    ScenarioAPIPermissions["WRITE_APPROVAL_DEVELOPMENT"] = "write:scenario:approval:development";
    ScenarioAPIPermissions["WRITE_APPROVAL_PROCUREMENT"] = "write:scenario:approval:procurement";
    ScenarioAPIPermissions["WRITE_APPROVAL_SUPER_ADMIN"] = "write:scenario:approval:super-admin";
    ScenarioAPIPermissions["WRITE_APPROVAL_ENGINEERING"] = "write:scenario:approval:engineering";
    ScenarioAPIPermissions["WRITE_APPROVAL_FINANCE"] = "write:scenario:approval:finance";
    ScenarioAPIPermissions["WRITE_APPROVAL_OWNER"] = "write:scenario:approval:owner";
})(ScenarioAPIPermissions || (ScenarioAPIPermissions = {}));
export var ProjectsAPIPermissions;
(function (ProjectsAPIPermissions) {
    ProjectsAPIPermissions["READ_US"] = "read:projects:us";
    ProjectsAPIPermissions["READ_ASIA"] = "read:projects:asia";
})(ProjectsAPIPermissions || (ProjectsAPIPermissions = {}));
export var ToolAPIPermissions;
(function (ToolAPIPermissions) {
    ToolAPIPermissions["READ_FIMO"] = "read:fimo";
    ToolAPIPermissions["READ_PVSIM"] = "read:pvsim";
    ToolAPIPermissions["READ_HVCOSTING"] = "read:hvcosting";
    ToolAPIPermissions["WRITE_PVCOSTING"] = "write:pvcosting";
    ToolAPIPermissions["READ_PVCOSTING"] = "read:pvcosting";
    ToolAPIPermissions["READ_PVCOSTING_DETAILED"] = "read:pvcosting-detailed";
    ToolAPIPermissions["READ_ESSCOSTING"] = "read:esscosting";
    ToolAPIPermissions["READ_ESSCOSTING_DETAILED"] = "read:esscosting-detailed";
    ToolAPIPermissions["WRITE_ESSCOSTING"] = "write:esscosting";
    ToolAPIPermissions["WRITE_PLANTSIM"] = "write:plantsim";
    ToolAPIPermissions["WRITE_PARCELS"] = "write:parcels";
})(ToolAPIPermissions || (ToolAPIPermissions = {}));
export var NewFeaturePermissions;
(function (NewFeaturePermissions) {
    NewFeaturePermissions["BETA"] = "beta";
})(NewFeaturePermissions || (NewFeaturePermissions = {}));
export var AppSystemPermissions;
(function (AppSystemPermissions) {
    AppSystemPermissions["SYSTEM_ADMIN"] = "app:system-admin";
})(AppSystemPermissions || (AppSystemPermissions = {}));
export const systemPermissions = Object.values(ToolAPIPermissions);
//# sourceMappingURL=permissions.js.map